const config = {
    allowedLocales: ['ru', 'en'] as const,
    fallbackLocales: {
        en: 'ru',
    },
    defaultFallback: 'ru' as const,
};

export type AllowedLocales = (typeof config.allowedLocales)[number];

export default config;
